export default __webpack_public_path__ + "ff5fbb56c45834d275e4357ff7d47106.glb";